module.exports = {
    site: {
        meta: {
            og_type: "article",
            og_site_name: "グローバルビジネス支援 | 株式会社オロ",
        }
    }

}
